<template>
  <form novalidate @submit.prevent="debounceSearch">
    <div class="columns my-0 is-multiline">
      <div class="column is-5">
        <kst-input load-on-focus floating-label
          field="Search" :data="searchData" :catalog="StkSearchCatalog"
          @input="handleInput"
        />
      </div>

      <div class="column is-narrow">
        <kst-button reset-mode @click="handleReset"/>
      </div>
    </div>
  </form>
</template>

<script>
import SearchMixin from "../../../mixins/SearchMixin.js";
import StkSearchCatalog from "../StkSearchCatalog.js";

export default {
  mixins: [SearchMixin],
  props: {
    searchData: Object
  },
  data: () => ({
    StkSearchCatalog: StkSearchCatalog
  }),
  created() {
    this.initSearch(this.searchData, this.submit);
  },
  methods: {
    handleInput() {
      this.handleSearch();
    },
    submit() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    }
  }
}
</script>